export default {
  components_Sunday: 'Sun.',
  components_Monday: 'Mon.',
  components_Tuesday: 'Tue.',
  components_Wednesday: 'Wed.',
  components_Thursday: 'Thur.',
  components_Friday: 'Fri.',
  components_Saturday: 'Sat.',
  components_browser_not_support_canvas: 'Your browser does not support canvas tags',
  components_expression: 'Stickers',
  components_make_comment: 'I have something to say',
  components_reply: 'Reply{name}: ',
  components_reply_btn: 'Reply',
  components_year_mouths: 'YYYY-MM',
  components_all_loaded: 'All loaded',
  components_Loading: 'Loading...',
  components_current_page_size: '{total, plural, =0 {no records} =1 {one record} other {# records}} found. Display entries {start} to {end}',
  components_many_attempts: 'Attempted too many times, please re-verify',
  components_many_refresh: 'Refreshed too many times, please re-verify',
  components_upload_files_empty: 'Upload file is empty, please select again',
  components_file_size_limit: "A single file cannot exceed {limitSize}M, please reselect",
  components_upload_time_out: 'Upload timeout!' ,
  components_net_error: "Network error!" ,
  components_uploading: 'Uploading...',
  components_uploadNumLimit: 'Up to {limit, plural, =0 {no files} =1 {one file} other {# files}} can be uploaded',
  components_most_num_limit: 'Up to {limit, plural, =0 {no files} =1 {one file} other {# files}} can be uploaded once',
  components_single_num_limit: 'Up to {limit, plural, =0 {no files} =1 {one file} other {# files}} can be uploaded once, please reselect',
  components_upload_failed: 'Failed to upload file!' ,
  components_files_time_out: 'Upload file timeout!' ,
  components_select_file: 'Select file',
  components_limit_num_types: '(You can upload up to {limit, plural, =0 {no attachments} =1 {one attachment} other {# attachments}} in word, excel, ppt, pdf, jpg, png format. File size cannot exceed {limitSize}M.)' ,
  components_please_upload_again: 'Upload file is empty, please re-upload',
  components_file_format_match: 'The file format does not match, please check and try again',
  components_limit_size_tip: 'Uploaded file size cannot exceeds {limitSize}M. Please re-upload',

}
